export default __webpack_public_path__ + "static/media/Info.2cd15b7b.svg";